import { CaseStudy } from '../../types';
import { LYRIC_SCROLLER_HERO } from '../../assets/images';

export const lyricScroller: CaseStudy = {
  id: '9',
  title: 'Lyric Scroller',
  category: 'Live Performance Tool',
  imageUrl: LYRIC_SCROLLER_HERO,
  description: 'The ultimate stage companion for musicians. Seamless lyrics scrolling, setlist management, and real-time tempo cues to keep your performance flawless.',
  screenshots: [],
  comingSoon: true
};